import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";

import AllAdminsLayer from "../../components/admins/AllAdminsLayer";
import Breadcrumb from "../../components/Breadcrumb";

const AllAdminsPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb routePath="/all-users" routeName="Home" title="Users" />

        <AllAdminsLayer />
      </MasterLayout>
    </>
  );
};

export default AllAdminsPage;
